import { render, staticRenderFns } from "./LogsIntegracaoDlg.vue?vue&type=template&id=64566cb7"
import script from "./LogsIntegracaoDlg.vue?vue&type=script&lang=js"
export * from "./LogsIntegracaoDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports